import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['item', 'all'];

    toggle(event) {
        event.preventDefault();

        event.currentTarget.classList.toggle('active');

        const anySelected = this.itemTargets.some((item) => item.classList.contains('active'));
        this.allTarget.classList.toggle('active', !anySelected);

        this.navigate();
    }

    selectAll(event) {
        event.preventDefault();

        this.itemTargets.forEach((item) => item.classList.remove('active'));
        this.allTarget.classList.add('active');

        this.navigate();
    }

    navigate() {
        const url = new URL(window.location);
        const selected = this.itemTargets
            .filter((item) => item.classList.contains('active'))
            .map((item) => item.dataset.id);

        Array.from(url.searchParams.keys())
            .filter((key) => /^category(\[\d*])?$/.test(key))
            .forEach((key) => url.searchParams.delete(key));

        selected.forEach((value) => url.searchParams.append('category[]', value));
        url.searchParams.set('paged', '1');
        window.location.href = url.href;
    }
}
